import { takeLatest, put, call } from "redux-saga/effects";
import service from "network/services/requestForCallback";
import type { ISaga } from "../types";
import {
  sendRequestForCallbackFailed,
  sendRequestForCallbackSuccess,
} from "../actionCreators";

export function* sendBusinessDetails({ payload }): ISaga {
  try {
    const resp = yield call(service.sendRequestForCallback, payload);

    // yield call(payload.onSuccess);
    yield put(sendRequestForCallbackSuccess());
  } catch (e) {
    yield put(sendRequestForCallbackFailed());
  }
}

export default function* watcher(): any {
  yield takeLatest("SEND_REQUEST_FOR_CALLBACK", sendBusinessDetails);
}
